import type { Palette } from '../types';

// Palette: . null, s silver, b blue, d dark, g gold, r red, p purple, w white, 1 grey, 2 brown, 3 green, y yellow
export const PALETTE: Palette = {
  '.': null,
  's': '#94a3b8',
  'b': '#3b82f6',
  'd': '#1e293b',
  'g': '#fbbf24',
  'r': '#ef4444',
  'p': '#a855f7',
  'w': '#fff',
  '1': '#475569',
  '2': '#78350f',
  '3': '#10b981',
  'k': '#000',
  'e': '#dc2626',
  'y': '#fcd34d'
};
